//More - Article, Connect and Fundme
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import painting from '../../assets/images/painting.jpg';
import './morecss.css';
import { getMethod } from '../../services/apiService';
import { IMG_URL } from '../../utility/config';
import LoadingSpinner from '../../utility/LoadingSpinner';
import { getGmailComposeUrl } from '../../utility/getGmailComposeUrl';

// Article Component
const Article = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const ARTICAL_BASE_URL = IMG_URL

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await getMethod('blog');

      // if (response && response.status && response.data && Array.isArray(response.data)) {
      if (response && response.status && response.data && Array.isArray(response.data.data)) {
        // setArticles(response.data.data); // correct array path


        setArticles(response.data.data.reverse());
      } else {
        console.error("Invalid response format:", response);
      }
      setLoading(false)
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div >
      {articles.map((article, index) => (
        <div key={index} className="article">
          {/* <h3 dangerouslySetInnerHTML={{ __html: article.title }} /> */}
          {/* <img className="articleimg"
            src={`${ARTICAL_BASE_URL}/${article.image}`}
            alt="article"
          /> */}
          <p className="articlep" dangerouslySetInnerHTML={{ __html: article.html_content }} />
        </div>
      ))}
    </div>
  );
};

// Connect Component
const AboutUs = () => {
  const [aboutus, setAboutus] = useState({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await getMethod('settings');
      if (response.status && response.data) {
        setAboutus(response.data);
      } else {
        console.error("Invalid response format:", response);
      }
      setLoading(false)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  if (loading) return <LoadingSpinner />;

  //button for gmail
  const handleClick = () => {
    const gmailUrl = getGmailComposeUrl('support@shentihilnathan.com')
    window.open(gmailUrl, '_blank', 'noopener,noreferrer');
  };


  return (
    <div className="placeholder-content">
      <h2>Connect</h2>
      <span className="social-link" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
        {aboutus.connect_instagram_link && (
          <a href={aboutus.connect_instagram_link} target="_blank" rel="noopener noreferrer">
            <img src={require('../../../src/assets/images/instagram.png')} alt="instagram" />
          </a>
        )}


        {/* {gmail-button} */}
        <button onClick={handleClick} style={{ border: 'none', background: 'none', padding: 0, cursor: 'pointer' }}>
          <img src={require('../../../src/assets/images/gmail.png')} alt="gmail" />
        </button>

        {aboutus.connect_youtube_link && (
          <a href={aboutus.connect_youtube_link} target="_blank" rel="noopener noreferrer">
            <img src={require('../../../src/assets/images/youtube.png')} alt="youtube" />
          </a>
        )}

      </span>
      <div>
        <p className="articlep" dangerouslySetInnerHTML={{ __html: aboutus.connect_description }} />
      </div>
    </div>
  );
};


//For Me Component
const FundMe = () => {
  const [fundme, setFundme] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate()

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await getMethod('settings');
      if (response.status && response.data) {
        console.log("my data", response.data)
        setFundme(response.data);
      } else {
        console.error("Invalid response format:", response);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  if (loading) return <LoadingSpinner />;

  // Function to extract YouTube video ID
  const getYoutubeEmbedUrl = (url) => {
    if (!url) return '';
    const regExp = /(?:youtube\.com\/.*(?:\?|&)v=|youtu\.be\/)([^#&?]{11})/;
    const match = url.match(regExp);
    if (!match) return '';
    const videoId = match[1];
    return `https://www.youtube.com/embed/${videoId}?autoplay=1&controls=0&loop=1&playlist=${videoId}&mute=1`;
  };

  const videoUrl = getYoutubeEmbedUrl(fundme.fundme_youtube);

  //fundme button
  const handleClick = () => {
    localStorage.setItem("selectedPoem", JSON.stringify({
      title: "For Me",
      id: "",
      description: "For Me",
      price: 5,
      type: "fund"
    }));
    console.log("afasfasf", localStorage)
    navigate(`/billing`);
  };

  return (
    <div className="placeholder-content">
      <h2>For Me</h2>
      <div className="social-link" style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
        {videoUrl && (

          <iframe
            width="560"
            height="315"
            src={videoUrl}
            title="YouTube video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen

          />
        )}
      </div>
      <div>
        <p className="fundme-content" dangerouslySetInnerHTML={{ __html: fundme.fundme_description }} />
      </div>

      {/* <button onClick={(e) => handleClick()} className="books-footer__button">
        For Me
      </button> */}
    </div>
  );
};

//MoreList
function Morelist() {

  const [activeTab, setActiveTab] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  const categories = ['Articles', 'Connect', 'ForMe'];         //For Me

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabFromURL = params.get('tab');

    if (tabFromURL && categories.includes(tabFromURL)) {
      setActiveTab(tabFromURL);
    } else {
      const defaultTab = categories[0];
      setActiveTab(defaultTab);
      navigate(`/more?tab=${encodeURIComponent(defaultTab)}`, { replace: true });
    }

  }, [location.search]);

  const renderContent = () => {
    switch (activeTab) {
      case 'Articles':
        return <Article />;
      case 'Connect':
        return <AboutUs />;
      case 'ForMe':        //For Me
        return <FundMe />;
      default:
        return null;
    }
  };

  //tab switch button
  const handleTabClick = (tab) => {
    if (tab != activeTab) {
      setActiveTab(tab);
      navigate(`/more?tab=${encodeURIComponent(tab)}`);
    }
  };

  return (
    <div className="morelist-container">
      <div className="tabs">
        {categories.map(category => (
          <button
            key={category}
            onClick={() => handleTabClick(category)}
            className={activeTab === category ? 'active' : ''}
            aria-pressed={activeTab === category}
          >
            {category=='ForMe'?"For Me":category}
          </button>
        ))}
      </div>
      <div className="grid-container-more">
        {renderContent()}
      </div>
    </div>
  );
}

export default Morelist;